import styled from 'styled-components';
import ListItem from '@material-ui/core/ListItem';

export const NavItem = styled(ListItem)`
  ${(props) => `
      height: 44px;
      margin-top: 2px;
      margin-bottom: 2px;
      padding-left:
        ${props.theme.direction === 'ltr' ? 17 + 50 * props.level : 12}px;
      padding-right:
        ${props.theme.direction === 'rtl' ? 17 + 50 * props.level : 12}px;
      color:
        ${
          props.themeMode === 'light'
            ? props.theme.palette.text.hint
            : 'rgba(255,255,255,0.38)'
        };
      font-weight: 700;
      font-size: 14px;
      cursor: pointer;
      text-decoration: none!important;

      ${props.theme.breakpoints.up('xl')} {
        font-size: 16px;
        margin-top: 4px;
        margin-bottom: 4px;
        padding-left:
          ${props.theme.direction === 'ltr' ? 24 + 50 * props.level : 12}px;
        padding-right:
          ${props.theme.direction === 'rtl' ? 24 + 50 * props.level : 12}px;
      }
      &.nav-item-header {
        text-transform: uppercase;
      }
  `}
`;
